"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDomainScale = exports.mapLabelColor = exports.MAP_STATE_ABBR = exports.MAP_LABEL_OVERRIDES = exports.MAP_SUPPRESSED_COLOR = exports.MAP_SEQUENTIAL_COLORS = exports.CHART_MAP_MIN_N = void 0;
exports.mapDomainOf = mapDomainOf;
exports.mapColorScale = mapColorScale;
const federal_state_1 = require("./federal-state");
/**
 * Small-group suppression: a Bundesland with fewer children (with a value of
 * the chosen measure at the chosen timepoint) is greyed out. Enforced in the
 * backend: n and value are not sent for such a region.
 */
exports.CHART_MAP_MIN_N = 5;
/**
 * Sequential map colours (light -> dark = low -> high), derived from the
 * GP Fit S brand: champagne ("Fit") to steel blue ("S") to brand blue ("P").
 * Lightness falls monotonically, so the order also holds in greyscale and
 * for colour vision deficiencies.
 */
exports.MAP_SEQUENTIAL_COLORS = [
    "#EAE4D6",
    "#BCCBD4",
    "#82A0B3",
    "#4A6F87",
    "#1D415A",
];
/** Fill of a suppressed (n < CHART_MAP_MIN_N) or empty Bundesland. */
exports.MAP_SUPPRESSED_COLOR = "#E5E7EB";
/**
 * Label anchors that differ from the generated centroid (AUSTRIA_STATE_SHAPES
 * .label): Wien and Burgenland are too small/narrow for a label and get one
 * outside with a leader line; Salzburg's centroid lies on the OÖ border.
 */
exports.MAP_LABEL_OVERRIDES = {
    [federal_state_1.FederalState.WIEN]: { at: [980, 34], leader: true },
    [federal_state_1.FederalState.BURGENLAND]: { at: [984, 380], leader: true },
    [federal_state_1.FederalState.SALZBURG]: { at: [400, 345], leader: false },
};
/** Short Bundesland labels on the map (common Austrian abbreviations). */
exports.MAP_STATE_ABBR = {
    [federal_state_1.FederalState.BURGENLAND]: "Bgld.",
    [federal_state_1.FederalState.KAERNTEN]: "Ktn.",
    [federal_state_1.FederalState.NIEDEROESTERREICH]: "NÖ",
    [federal_state_1.FederalState.OBEROESTERREICH]: "OÖ",
    [federal_state_1.FederalState.SALZBURG]: "Sbg.",
    [federal_state_1.FederalState.STEIERMARK]: "Stmk.",
    [federal_state_1.FederalState.TIROL]: "T",
    [federal_state_1.FederalState.VORARLBERG]: "Vbg.",
    [federal_state_1.FederalState.WIEN]: "W",
};
/** Text colour that stays readable on a sequential bin (dark bins: white). */
const mapLabelColor = (bin) => bin >= 3 ? "#FFFFFF" : "#0B2A40";
exports.mapLabelColor = mapLabelColor;
/** Colour scale of a shared domain ("Gegenüberstellen": both maps alike). */
const mapDomainScale = (domain) => domain ? mapColorScale([domain.min, domain.max]) : null;
exports.mapDomainScale = mapDomainScale;
/** Domain of a list of shown values (null entries are ignored). */
function mapDomainOf(values) {
    const finite = values.filter((v) => v !== null && Number.isFinite(v));
    return finite.length
        ? { min: Math.min(...finite), max: Math.max(...finite) }
        : null;
}
/**
 * Equal-interval bins between the smallest and largest shown value. One
 * value (or all equal) -> the middle bin.
 */
function mapColorScale(values) {
    const finite = values.filter((v) => Number.isFinite(v));
    if (finite.length === 0)
        return null;
    const min = Math.min(...finite);
    const max = Math.max(...finite);
    const bins = exports.MAP_SEQUENTIAL_COLORS.length;
    if (max === min) {
        return { edges: [min, max], binOf: () => Math.floor(bins / 2) };
    }
    const step = (max - min) / bins;
    const edges = Array.from({ length: bins + 1 }, (_, i) => min + i * step);
    return {
        edges,
        binOf: (v) => Math.min(bins - 1, Math.max(0, Math.floor((v - min) / step))),
    };
}
